module.exports = __webpack_public_path__ + "static/media/icon_cashPayment.ccf10303.png";